const BASE_URL = "https://api.themoviedb.org/3";
const API_KEY = "0425708b766634a264f7b84cc81ebcd7";
const BASE_IMG_URL = "https://image.tmdb.org/t/p/w300";

export { BASE_URL, API_KEY, BASE_IMG_URL };
